module.exports = __webpack_public_path__ + "static/media/Minotaur.a3027552.jpg";